import hasCapitalizedFields from './utilities/hasCapitalizedFields';

const trainingProgram = (trainingProgramJson) => {
  const properties = {
    ...trainingProgramJson.attributes,
    guid: trainingProgramJson.guid,
  };
  return Object.assign(
    properties,
    hasCapitalizedFields(trainingProgramJson.attributes),
  );
};

export default trainingProgram;
